import { useFeatureFlags } from 'hooks/useFeatureFlags';

import { useHasPermission } from './queries/useHasPermission';

export function useHasLeaderboardPermission() {
  const flags = useFeatureFlags();
  const hasPermission = useHasPermission('skyslope.leaderboard.*');
  return {
    // return isLoading incase we need to wait before we know if the user has permission
    isLoading: hasPermission === null,
    data: flags.isBuyerAgreementBrokerLeaderboardEnabled && hasPermission,
  };
}
